import script from "./unbindContactModal.vue?vue&type=script&setup=true&lang=js"
export * from "./unbindContactModal.vue?vue&type=script&setup=true&lang=js"

import "./unbindContactModal.vue?vue&type=style&index=0&id=5eb127ea&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb127ea"]])

export default __exports__